/**
 * useRecentRuns.ts -- TDD stub. Will be fully implemented by T330.
 *
 * This file exists to allow T329 red-phase tests to resolve mocks.
 */

export interface RecentRunItem {
  id: string;
  label: string;
  href: string;
}

export interface UseRecentRunsResult {
  status: "loading" | "ready" | "empty" | "error" | "forbidden";
  data: RecentRunItem[];
}

export function useRecentRuns(_workspaceSlug?: string): UseRecentRunsResult {
  return { status: "loading", data: [] };
}
